export const environment = {
  production: false,
  apiUrl: 'https://nom035.afirma.solutions/api/v1',
  apiGatewayUrl: 'https://nom035.afirma.solutions/api/v1',
};